// Import functions from the SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Auth ke liye
import { getFirestore } from "firebase/firestore"; // Database ke liye

const firebaseConfig = {
  apiKey: "AIzaSyDBfuIOwsdlhAXkmBh4QwOU650qVJ461X0",
  authDomain: "portfolio-8f139.firebaseapp.com",
  projectId: "portfolio-8f139",
  storageBucket: "portfolio-8f139.firebasestorage.app",
  messagingSenderId: "149938432048",
  appId: "1:149938432048:web:e8cd29c191af6ea81525f5",
  measurementId: "G-CBXS0LGC73"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Services ko export karein taaki AuthContext aur components use kar sakein
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analyticsService = analytics;

export default app;